export default {
  OPEN: 'OPEN',
  HOLD: 'HOLD',
  ORDER_VERIFIED: 'ORDER_VERIFIED',
  ORDER_VERIFICATION: 'ORDER_VERIFICATION',
  ADDED_TO_SHIPMENT: 'ADDED_TO_SHIPMENT',
  READY_FOR_SHIPMENT: 'READY_FOR_SHIPMENT',
  SHIPPED: 'SHIPPED',
  ORDER_RE_VERIFICATION: 'ORDER_RE_VERIFICATION',
  CANCELED: 'CANCELED',
  EXPIRED: 'EXPIRED',
  TRANSFERRED: 'TRANSFERRED',
  FILL_LATER: 'FILL_LATER',
};

export const ExternalOrdersFieldKeys = {
  ORDER_ID: 'orderId',
  CREATED_AT: 'createdAt',
  STATUS: 'status',
  PATIENT_NAME: 'patientName',
  PARTNER_NAME: 'partnerName',
  PARTNER_ACCOUNT: 'partnerAccount',
};

export const orderSource = {
  0: { sourceKey: 'NA', sourceValue: '' },
  1: { sourceKey: 'API', sourceValue: 'API' },
  2: { sourceKey: 'Portal', sourceValue: 'Portal' },
  3: { sourceKey: 'Manual', sourceValue: 'Manual Entry' },
  4: { sourceKey: 'Docu', sourceValue: 'SureScripts' },
  5: { sourceKey: 'File', sourceValue: 'File Import' },
};
